<template>
  <header class="header--wrap"
          :class="{ minimized: gnbMinimized < 0,
                    expanded: gnbMinimized > 1,
                    animating}">
    <div>
      <logo :isHorizontal="true"></logo>
      <slot/>
      <div class="header" v-if="userData">
        <div class="button--area clearfix">
          <button class="user-menu"
                  @click.stop.prevent="toggleUserMenu">
            <i class="icon icon--user"></i>
          </button>
          <transition name="slide">
            <user-menu v-if="showUserMenu" />
          </transition>
        </div>

        <report-control class="journey-control"
                        :domains="domains"
                        @onLoading="$emit('onLoading', $event)" @setSegmentPayment="setSegmentPayment"/>
        <div class="minimize">
          <i class="icon icon--bc-tab-btn" @click.stop="onGnbMinimize"></i>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import UserMenu from '@/components/header/UserMenu'
import ReportControl from '@/components/report/Control'
import Logo from '@/components/common/Logo.vue'

export default {
  name: 'AppHeader',
  components: {
    Logo,
    UserMenu,
    ReportControl
  },
  props: [ 'domains' ],
  computed: {
    ...mapState([
      'userData',
      'showUserMenu',
      'gnbMinimized',
      'journeyOptions',
      'journeyPeriod',
      'journeyTargetingOptions',
      'isDemo'
    ]),
    reportView () {
      return this.$route.name
    }
  },
  data () {
    return {
      animating: false
    }
  },
  mounted () {
    EventBus.$on('closeUserMenu', () => {
      this.setShowUserMenu(false)
      this.showLanguageListStatus = false
    })
  },
  methods: {
    ...mapMutations([
      'setShowUserMenu',
      'setBaGnbMinimized'
    ]),
    setSegmentPayment () {
      this.$emit('setSegmentPayment')
    },
    onGnbMinimize () {
      this.setBaGnbMinimized(this.gnbMinimized < 0 ? 0 : -1)
      this.animating = true
      setTimeout(() => {
        this.animating = false
      }, 300)
    },
    toggleUserMenu () {
      EventBus.$emit('closeAllUiSelectBox')
      EventBus.$emit('closeDateRangePicker')
      EventBus.$emit('closeReferrerList')
      EventBus.$emit('closeJourneyPageList')
      this.setShowUserMenu(!this.showUserMenu)
      this.showLanguageListStatus = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header--wrap {
  position: relative;
  z-index: 100;

  .header {
    position: relative;
    z-index: 1;
    height: 106px;
    padding-left: 0;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08);
    transition: height 0.3s ease;
  }

  .journey-control {
    position: relative;
    width: 100%;
    z-index: 1;
    top: 0;
    transition: top 0.3s ease;
  }

  .minimize {
    position: absolute;
    bottom: -9px;
    right: 34px;
    z-index: 1;
    display: inline-block;
    width: 33px;
    height: 17px;
    background: #fff;
    border-radius: 5px;

    .icon {
      padding: 10px;
      background-position: 10px 0;
      background-size: 12px 12px;
      width: 10px;
      height: 15px;
      transition: transform 0.2s ease;
    }
  }

  .button--area {
    display: inline-block;
    position: absolute;
    z-index: 30;
    top: 12px;
    right: 15px;
    transform: none;

    button.user-menu {
      width: 30px;
      height: 30px;
      border-radius: 15px;
      display: inline-block;
      vertical-align: middle;
      transition: background-color 0.2s ease;
      margin: -3px -5px 0 0;

      .icon--user {
        margin: 0;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.06);
      }
    }
  }

  &.minimized {
    .logo {
      top: 10px;
    }

    .header {
      height: 53px;
    }

    .journey-control {
      & /deep/ {
        .control-top {
          .site-list {
            transform: translateY(10px);
          }
        }
        .docent-wrap {
          transform: translateY(-60px);
          opacity: 0;
        }

        .control-bottom {
          .view-control{
            transform: translateY(-55px);
          }
        }
      }
    }

    .minimize {
      i {
        transform: scaleY(-1) translateY(21px);
      }
    }
  }

  &.animating,
  &.minimized {
    .journey-control {
      & /deep/ {
        .control-top, .control-bottom {
          overflow: hidden;
        }
      }
    }
  }

  &.expanded {
    .header {
      height: 261px;
    }
  }
  &.banner {
    .minimize {
      // display: none;
      pointer-events: none;
      cursor: default;
    }
  }
}
</style>
